<template>
  <header>
    <RouterLink
      class="logotype-container"
      to="/"
      @click.native="closeMenu"
    >
      <EventManagerLogotype
        class="logotype"
        :fill-color="selectedTheme.contrast.text.hex"
      />
    </RouterLink>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import MutationTypes from '@/store/constants/mutations';
import GetterTypes from '@/store/constants/getters';
import EventManagerLogotype from '@/components/layout/navigation/menu/EventManagerLogotype.vue';

export default {
  name: 'MainMenuHeader',
  components: { EventManagerLogotype },
  computed: {
    ...mapGetters([
      GetterTypes.PACKAGE_NAME,
      GetterTypes.MENU_EVENT_BUS,
    ]),
  },
  methods: {
    closeMenu() {
      this.menuEventBus.emit('close-all');
      this.$store.commit(MutationTypes.SET_SHOW_MENU, false);
    },
  },
};
</script>

<style lang="scss" scoped>
  header {
    display: grid;
    align-items: center;
    padding: 0 20px;

    .logotype {
      cursor: pointer;
      padding-top: 25px;
      align-items: center;
      justify-content: flex-end;
      display: flex;

      @media screen and (min-width: $mediumLargeBreakpoint) {
        display: none;
      }
    }
  }
</style>
